__turbopack_context__.v({
  "calculator_cta": "styles-module-scss-module__rvDa8W__calculator_cta",
  "chart_wrapper": "styles-module-scss-module__rvDa8W__chart_wrapper",
  "condensed": "styles-module-scss-module__rvDa8W__condensed",
  "cta_wrapper": "styles-module-scss-module__rvDa8W__cta_wrapper",
  "current": "styles-module-scss-module__rvDa8W__current",
  "hide_visual": "styles-module-scss-module__rvDa8W__hide_visual",
  "legend_color": "styles-module-scss-module__rvDa8W__legend_color",
  "legend_container": "styles-module-scss-module__rvDa8W__legend_container",
  "legend_item": "styles-module-scss-module__rvDa8W__legend_item",
  "legend_label": "styles-module-scss-module__rvDa8W__legend_label",
  "legend_value": "styles-module-scss-module__rvDa8W__legend_value",
  "refinance": "styles-module-scss-module__rvDa8W__refinance",
  "results_header": "styles-module-scss-module__rvDa8W__results_header",
  "savings_amount": "styles-module-scss-module__rvDa8W__savings_amount",
  "savings_display": "styles-module-scss-module__rvDa8W__savings_display",
  "savings_period": "styles-module-scss-module__rvDa8W__savings_period",
  "select_wrapper": "styles-module-scss-module__rvDa8W__select_wrapper",
  "tooltip_header": "styles-module-scss-module__rvDa8W__tooltip_header",
  "tooltip_row": "styles-module-scss-module__rvDa8W__tooltip_row",
  "tooltip_summary": "styles-module-scss-module__rvDa8W__tooltip_summary",
});
